var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M163.2 195.2c-1 .5-2 .8-3 1s-2.2 0-3.2-.3c-1.1-.3-2-.8-2.8-1.6s-1.5-1.5-2-2.5l-38.1-71.7-39.1 65c-1.1 1.9-3 3.2-5 3.7s-4.3.2-6.2-.9-3.2-3-3.7-5-.2-4.3.9-6.2l39.1-65H18.7c-1.1 0-2.1-.3-3.1-.7-1-.4-1.9-1-2.7-1.7s-1.4-1.7-1.8-2.7c-.5-1-.6-2-.6-3.2 0-1.1.3-2.2.6-3.1.4-1 1-1.9 1.8-2.6.8-.8 1.6-1.4 2.7-1.8 1-.5 2.1-.6 3.1-.6h82L62.2 23c-.5-.9-.9-2-1-3 0-1.1 0-2.1.3-3.2.3-1 .8-2 1.5-2.8.7-.8 1.5-1.5 2.5-2s2-.8 3.1-.9c1.1 0 2.2 0 3.2.3s2 .8 2.8 1.6 1.5 1.5 2 2.5l38.1 71.7 39.1-65c1.1-1.9 3-3.2 5-3.7s4.3-.2 6.2.9 3.2 3 3.7 5c.5 2.1.2 4.3-.9 6.2l-39.1 65h81.2c1.1 0 2.1.2 3.1.6 1 .4 1.9 1 2.7 1.7s1.4 1.7 1.8 2.7c.5 1 .6 2.1.6 3.2s-.3 2.2-.6 3.1c-.4 1-1 1.9-1.8 2.6s-1.6 1.4-2.7 1.8c-1 .5-2.1.6-3.1.6h-82l38.5 72.3c.5 1 .8 2 1 3s0 2.2-.3 3.2c-.3 1.1-.8 2-1.5 2.8-.7.8-1.5 1.5-2.5 2Z"}));
}

Logo.defaultProps = {"viewBox":"0 0 228.7 206.9"};

module.exports = Logo;

Logo.default = Logo;
